import React from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

export const WhatsAppFloat = () => {
  const msg = encodeURIComponent(
    "Hello Hasan Javed Glass & Aluminum, I'd like to inquire about your services."
  );
  const link = `https://wa.me/${COMPANY.whatsapp}?text=${msg}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] hover:bg-[#20BD5A] text-white flex items-center justify-center shadow-2xl wa-pulse transition-colors"
    >
      <MessageCircle className="h-7 w-7 md:h-8 md:w-8" />
    </a>
  );
};
